import React from "react";
import styled from "styled-components";
import { Typography } from "../core";
import { theme, MixStyle } from "../styles";
const { textColor, colors } = theme;

const billsColumns = [
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 150,
  },
  {
    title: "Ammount",
    dataIndex: "ammount",
    key: "ammount",
    width: 150,
  },
];

const StyledTabel = styled.table`
  display: block;
  padding-bottom: 20px;
  border-bottom: 2px solid #b9b9b9;
  tr {
    padding: 20px 20px;
    ${MixStyle.flexBetween};
  }
  tbody tr:nth-child(odd) {
    background: #e9f2ff;
  }
  tr:nth-child(even) {
    background: #ffffff;
  }
  tbody tr {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #979ba4;
  }
  thead tr {
    background: ${colors.Fiord};
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: white;
  }
  thead,
  tbody {
    display: block;
  }
`;
const OtherBills = ({ otherBills, className, ...props }) => {
  return (
    <>
      <Typography
        as="h3"
        weight="bold"
        letterSpacing="0.2px"
        color={textColor.primary}
      >
        Other Bills
      </Typography>
      <StyledTabel>
        <thead>
          <tr>
            {billsColumns.map((items, index) => {
              return <th key={index}>{items.title}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {otherBills.map((items, index) => {
            return (
              <tr key={index}>
                <td>{items.description ? items.description : ""}</td>
                <td>{items.ammount}</td>
              </tr>
            );
          })}
        </tbody>
      </StyledTabel>
    </>
  );
};
export default OtherBills;
